import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/lib/LanguageContext";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/sections/HeroSection";
import AntiFrictionBar from "@/components/sections/AntiFrictionBar";
import ValueStack from "@/components/sections/ValueStack";
import HowItWorks from "@/components/sections/HowItWorks";
import PricingSection from "@/components/sections/PricingSection";
import AirtableTemplateSection from "@/components/sections/AirtableTemplateSection";
import NoListSection from "@/components/sections/NoListSection";
import FAQSection from "@/components/sections/FAQSection";

const Home = () => {
  const [selectedTier, setSelectedTier] = useState(null);

  return (
    <div className="min-h-screen dark-gradient-bg noise-overlay relative">
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            background: 'rgba(15, 20, 25, 0.9)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#fff',
          },
        }}
      />

      <Header />

      <main className="relative z-10">
        <HeroSection selectedTier={selectedTier} setSelectedTier={setSelectedTier} />
        <AntiFrictionBar />
        <ValueStack />
        <HowItWorks />
        <PricingSection onSelectTier={setSelectedTier} />
        <AirtableTemplateSection />
        <NoListSection />
        <FAQSection />
      </main>

      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
